import HeaderTopBrand from '../../../../components/header-top-brand';
import headerTopBrand from './header-top-brand';

const configureHeaderTopBrand = headerTopBrand(HeaderTopBrand);

export default configureHeaderTopBrand;
